






























import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class InputField extends Vue {
  @Prop({ default: null }) public label!: string | null;
  @Prop({ default: null }) public helperText!: string | null;
  @Prop({ default: false }) public isDirty!: boolean;
  @Prop({ default: false }) public isDisabled!: boolean;
  @Prop({ default: false }) public isFocused!: boolean;
  @Prop({ default: false }) public isInvalid!: boolean;
  @Prop({ default: null }) public warningText!: string | null;
  @Prop({ required: true }) public type!: string;

  get inputClass() {
    let inputClasses = "InputField__input w-full pt-3 left-0 bg-transparent transition text-grey";
    if (this.type !== "textarea") {
      inputClasses += " border-b border-theme-input-field-border h-10";
    }
    return inputClasses;
  }
}
